import React from 'react';
import ReactDOM from 'react-dom';
import xhr from 'xhr';
import { API_TOKEN } from 'constants';
import LoadingSection from 'components/loading';
import Member from './member';

class MemberList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      groups: [],
      currentMemberId: 0,
      isEditMode: false
    }
  }

  componentDidMount() {
    this.loadMembersFromServer();
    this.setState({
      groups: PT.customerGroups,
      currentMemberId: PT.currentMember.id,
      isEditMode: this.isEditAllForm()
    });
  }

  isEditAllForm() {
    return (window.location.pathname == '/account/members/edit');
  };

  bindLiveFilter() {
    let $filterList = $('#filter_members');

    if ($filterList.length) {
      $filterList.liveFilter('[data-members-list]');
    }
  };

  loadMembersFromServer() {
    xhr('/api/v1/users.json', {
      headers: { 'X-Papertrail-Token': API_TOKEN },
      onSuccess: (users) => {
        this.setState({ users: users });
        this.bindLiveFilter();
      }
    });
  };

  render() {
    if (!this.state.users.length) {
      return <LoadingSection text="Loading Members..." />;
    }

    const members = this.state.users.map((user) => (
      <Member
        key={user.id}
        id={user.id}
        email={user.email}
        memberId={user.member.id}
        isEditMode={this.state.isEditMode}
        isEditAllForm={this.isEditAllForm()}
        readOnly={user.member.read_only}
        receiveBillingEmails={user.member.receive_billing_emails}
        receiveUsageEmails={user.member.receive_usage_emails}
        canAccessAllGroups={user.member.can_access_all_groups}
        manageMembers={user.member.manage_members}
        manageBilling={user.member.manage_billing}
        purgeLogs={user.member.purge_logs}
        hasLogAccess={user.member.has_log_access}
        groupIds={user.member.group_ids}
        editableNotifications={user.member.editable_notifications}
        groups={this.state.groups}
        sso={user.customer.sso}
        paysSomeoneElse={user.customer.pays_someone_else}
        isCurrentMember={this.state.currentMemberId == user.member.id}
        bindLiveFilter={this.bindLiveFilter}
      />
    ));

    return (
      <ul data-members-list>
        {members}
      </ul>
    );
  }
};

$(function() {
  ReactDOM.render(<MemberList />, document.getElementById('members-ui'));
});
